<template>
    <div>
        <div class="lists">
            <div class="listItem flx alc" v-for="item,index in array">
                <div class="liLeft">
                    <div class="liName" v-text="item.name"></div>
                    <div class="liDes">
                        {{item.city_name}}丨 {{item.exp_name}}丨{{item.eb_name == '不限'?'学历不限' : item.eb_name}}丨{{item.salary_mix}}K-{{item.salary_max}}K
                    </div>
                </div>
                <div class="liMiddle cursor" @click.stop="toresume(item)">
                    <div class="liTop" v-text="item.resume_num"></div>
                    <div class="liDes">
                        投递简历
                    </div>
                </div>
                <div class="liRight flx alc" :style="type == 2?'visibility:hidden' : ''">
                    
                    <div class="bluebtn cursor" style="margin-left: 12px;" @click.stop="showReason(item)" v-if="type == 3">
                        <img :src="$Localimg('ic5.png')" alt="" /><span>驳回原因</span>
                    </div>
                    
                    <div class="redbtn cursor" style="margin-left: 12px;" v-if="type == 1 || type == 3 || type == 4" @click.stop="delItem(item)" >
                        <img :src="$Localimg('ic8.png')" alt="" /><span>删除</span>
                    </div>
                    
                    <div class="bluebtn cursor" style="margin-left: 12px;" v-if="type == 0 || type == 1 || type == 3 || type == 4" @click.stop="toEdit(item)">
                        <img :src="$Localimg('ic10.png')" alt="" /><span>修改</span>
                    </div>
                    
                    <div class="bluebtn cursor" style="margin-left: 12px;" @click.stop="downLine(item)" v-if="type == 0">
                        <img :src="$Localimg('ic1.png')" alt="" /><span>下线</span>
                    </div>
                    
                    <div class="bluebtn cursor" style="margin-left: 12px;" @click.stop="upLine(item)" v-if="type == 1">
                        <img :src="$Localimg('ic5.png')" alt="" /><span>上线</span>
                    </div>
                </div>
            </div>
        </div>
        <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :total="total" :hide-on-single-page="true">
        </el-pagination>
        <el-dialog title="驳回原因" :visible.sync="centerDialogVisible" width="30%" center>
            <div style="white-space: pre-wrap;" v-text="reasons"></div>
            <span slot="footer" class="dialog-footer">
                <el-button round type="primary" @click="centerDialogVisible = false">我已知晓</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {
        recriList,
        updownRe
    } from "@/api/index.js"
    import { bus } from '@/bus.js'
    export default {
        name: 'reList',
        data() {
            return {
                centerDialogVisible: false,
                activeName: '0',
                info: {
                    level: 2
                },
                array: [],
                showLogin: false,
                page: 1,
                status: 0,
                total: 0,
                reasons: ""
            };
        },
        props: ['type'],
        created() {
            this.getList()
        },
        methods: {
            toresume(e){
                let that = this
                that.$router.push({
                    path: '/Resume', // 写路由path
                    query: {
                        id: e.id
                    }
                })
            },
            toEdit(e) {
                let that = this
                that.$router.push({
                    path: '/PositionEdit', // 写路由path
                    query: {
                        id: e.id,
                        source: that.type == 4 ? 2 : 1
                    }
                })
            },
            showReason(e) {
                this.reasons = e.remark
                this.centerDialogVisible = true
            },
            delItem(e) {
                let that = this
                let data = {}
                data.id = e.id
                data.type = that.type == 4?4 : 3
                that.$confirm('确定要删除该招聘信息吗?', ' ', {
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    updownRe(data).then((res) => {
                        console.log(res)
                        if (res.code == 1) {
                            that.$message({
                                type: 'success',
                                message: res.msg
                            });
                            that.$emit("rfh")
                            that.getList()
                        } else {
                            that.$message({
                                type: 'error',
                                message: res.msg
                            });
                        }
                    })
                }).catch(() => {

                });
            },
            upLine(e) {
                let that = this
                let data = {}
                data.id = e.id
                data.type = 2
                that.$confirm('确定要上线该招聘信息吗?', ' ', {
                    confirmButtonText: '上线',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    updownRe(data).then((res) => {
                        console.log(res)
                        if (res.code == 1) {
                            that.$message({
                                type: 'success',
                                message: res.msg
                            });
                            that.getList()
                        } else {
                            that.$message({
                                type: 'error',
                                message: res.msg
                            });
                        }
                    })
                }).catch(() => {

                });
            },
            downLine(e) {
                let that = this
                let data = {}
                data.id = e.id
                data.type = 1
                that.$confirm('确定要下线该招聘信息吗?', ' ', {
                    confirmButtonText: '下线',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    updownRe(data).then((res) => {
                        console.log(res)
                        if (res.code == 1) {
                            that.$message({
                                type: 'success',
                                message: res.msg
                            });
                            that.getList()
                        } else {
                            that.$message({
                                type: 'error',
                                message: res.msg
                            });
                        }
                    })
                }).catch(() => {

                });
            },
            handleCurrentChange(e) {
                console.log(e)
                this.page = e
                this.getList()
            },
            getList() {
                let that = this
                let data = {}
                data.page = that.page
                data.size = 30
                data.is_status = that.type
                recriList(data).then((res) => {
                    if (res.code == 1) {
                        that.array = res.data.list.data
                        that.total = res.data.list.total * 1
                        let nums = []
                        nums.push(res.data.num1)
                        nums.push(res.data.num2)
                        nums.push(res.data.num3)
                        nums.push(res.data.num4)
                        nums.push(res.data.num5)
                        that.$emit("getNums", nums)
                    } else {
                        // that.$message.error(res.msg)
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .liLeft{
        width: 40%;
    }
    .liRight{
        flex: 1;
        justify-content: flex-end;
    }
    .liEdit {
        font-size: 16px;
        color: #007AFF;
    }

    .liDes {
        font-size: 14px;
        color: #999999;
        text-align: left;
    }

    .liTop {
        font-weight: 500;
        font-size: 20px;
        color: #222222;
        line-height: 28px;
        margin-bottom: 4px;
    }

    .liName {
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 16px;
        text-align: left;
    }

    .liDes {
        font-size: 14px;
        color: #555C70;
    }

    .listItem {
        box-sizing: border-box;
        padding: 20px 30px;
        border-radius: 10px;
        border: 1px solid #D9D9D9;
        margin-bottom: 20px;
    }

    .lists {
        box-sizing: border-box;
        padding: 0 30px 0;
    }

    .acctitle {
        box-sizing: border-box;
        padding: 28px 30px 0;
    }
</style>